import { render, staticRenderFns } from "./detailStaffGroup.vue?vue&type=template&id=2e6872fa&scoped=true&"
import script from "./detailStaffGroup.vue?vue&type=script&lang=js&"
export * from "./detailStaffGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6872fa",
  null
  
)

export default component.exports